
import CommonUtils from "@/common-utils";
import { OrderMetaVO } from "@/views/biz/order/vo/order.vo";
import { UgcVO, SlvUgcImgVO, RelUgcProductVO, UgcPointPolicy } from "@/views/biz/ugc/vo/ugc.vo";
import axios from "axios";
import imageCompression from "browser-image-compression";
import  debounce  from "lodash-es/debounce";
import VideoSnapshot from "video-snapshot";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Constants from "../../../constants";
import ReviewProductSearchPop from "./ReviewProductSearchPop.vue";
import CommonModalDialog from "@/components/CommonModalDialog.vue";
import CropModal from "./CropModal.vue";


@Component({ components: { CropModal,
  ReviewProductSearchPop, CommonModalDialog } })
export default class ReviewForm extends Vue {
  maxUploadCount = 10;
  maxImageSizeMB = 0.3;
  maxVideoSizeMB = 50;
  ugcTypeCd = "047001"; // 리뷰
  tempCropped="";
  tempFile=new File([""], "filename") as File;

  doCrop = false;
  imageList = [] as Array<Blob>;

  fileListLength = 0; // 크롭모달창 오픈시 이미지 개수 맞는지 판단하기위함
  //data
  @Prop() ugcCd?: number;
  @Prop() propProduct?: RelUgcProductVO;
  review: UgcVO = {} as UgcVO;
  @Prop() mainMenuIdx?: number; // 메인 메뉴 리뷰 idx (쓰기 완료 시 메인화면의 해당 idx로 라우팅)

  // 자동 저장 복구 안내 팝업
  showSavedDocumentPop = false;
  // 상품 선택 팝업
  showProductPop = true;

  // 리뷰 이미지 swiper
  swipers = {
    slidesPerView: 3.5,
    spaceBetween: 7,
    lazy: true,
  };

  // meta(지급 포인트 정보)
  meta = [] as Array<UgcPointPolicy>;

  // computed

  get product() {
    try {
      return this.review.products[0];
    } catch (e) {
      return {} as RelUgcProductVO;
    }
  }
  set product(product: RelUgcProductVO) {
    this.$set(this.review, "products", [product]);
  }

  get reviewTextLength() {
    const removedConsecutiveText = this.review.text.replace(/(.)\1{4,}/g, '');
    return removedConsecutiveText.length
  }

  // methods

  @Watch("showProductPop")
  onProductPopStatusChange() {
    if (!this.ugcCd && this.showProductPop == false && !this.review.products) {
      // 수정 아님 && 상품선택팝업 아님 && 상품선택 안함
      // 리뷰쓰기 -> 상품선택 -> (상품선택안하고) 뒤로가기
      this.$router.go(-1);
    }
  }

  // 파일 추가
  btnAddFile() {
    if (this.review.files && this.review.files.length >= this.maxUploadCount) {
      // 최대 10개까지 등록 가능합니다
      alert(this.$t("review.a0011").toString());
      return;
    }
    (this.$refs.imgFile as HTMLInputElement).click();
  }

  /**
   * 이미지 사이즈 조정
   */
  async getResizedImage(imageFile: File): Promise<File> {
    const options = {
      maxSizeMB: this.maxImageSizeMB,
      maxWidthOrHeight: 1024,
      useWebWorker: true,
    };
    const compressedFile: Blob = (await imageCompression(imageFile, options)) as Blob;
    return new File([compressedFile], imageFile.name, { type: imageFile.type });

    //return imageFile;
  }

  /**
   * 동영상 사이즈 조정
   */
  async getResizedVideo(videoFile: File): Promise<File> {
    // TODO 리사이즈
    return videoFile;
  }

  /**
   * 동영상 스냅샷
   */
  async getSnapShot(videoFile: File): Promise<File> {
    const snapshoter = new VideoSnapshot(videoFile);
    const test = await snapshoter.takeSnapshot();
    return fetch(test)
      .then((r) => r.blob())
      .then((blob) => {
        return new File([blob], "snapshot.png");
      });
  }

  // 이미지 사진 업로드 후 저장된 값 리턴
  async uploadFile(e) {
    const fileList = e.target.files as FileList;
  
    if (this.review.files && fileList.length + this.review.files.length > this.maxUploadCount) {
      // 최대 10개까지 등록 가능합니다
      alert(this.$t("review.a0011").toString());
      return;
    }
    this.fileListLength =0;

    for (let i = 0; i < fileList.length; i++) {
    
      const file = fileList.item(i);
      if (file == null) {
        continue;
      }

      const filenm = file.name;
      const ext = filenm.split(".")[1].toLowerCase();
      const types = file.type; // video/quicktime, image/png
      const type = types.split("/")[0];
      const size = file.size / 1000000; // conver Byte to MB

      let uploadFile!: File;
      let uploadFile2!: File;
      let uploadUrl!: string;

      switch (type) {
        case "image": // 이미지
          uploadUrl = "/ugc/image";
          
          //크롭시 이미지 개수 맞는지 여부 확인용
          this.fileListLength += 1;


          if (ext.startsWith("jp") == false && ext != "png") {
            // 이미지는 JPG, PNG파일만 가능합니다.
            this.$toast(this.$t("review.a0021").toString());
            return;
          }

          uploadFile = await this.getResizedImage(file);
      
        //  this.tempCropped = window.URL.createObjectURL(uploadFile);
          this.imageList.push(uploadFile);
          this.doCrop = true;
          break;
        case "video": // 동영상
          if (size > this.maxVideoSizeMB) {
            // 동영상은 50MB까지 가능합니다
            this.$toast(this.$t("review.a0013").toString());
            return;
          }
          if (ext === "avi" || ext === "mkv") {
            //동영상은 mp4, mov 형식만 지원 가능합니다
            this.$toast(this.$t("review.a0014").toString());
            return;
          }
          uploadUrl = "/ugc/video";

          uploadFile = await this.getSnapShot(file);
          uploadFile2 = await this.getResizedVideo(file);
          break;
        default:
          // 파일의 확장자를 확인해주세요.
          this.$toast(this.$t("review.a0022").toString());
          return;
      }

      // review img는 파일 타입을 저장해야 해서 하나씩 post함
      const formData = new FormData();
      formData.append("bizType", "review");
      // 이미지 파일, 비디오 스냅샷
      formData.append("file1", uploadFile, uploadFile.name);
      // 비디오파일
      if (uploadFile2) {
        formData.append("file2", uploadFile2, uploadFile2.name);
        this.saveImageApi(uploadUrl, formData);

      }
    
    }
  }

  saveCroppedImage(list: Array<Blob>){
    const images = list? list : this.imageList;
    for(const image of images){
      const formData = new FormData();
      const urlFromImage = URL.createObjectURL(image);
  
      const imageName = urlFromImage.replace("blob:"+window.location.protocol+"//"+window.location.host+"/","");
      const imageType = image.type.split("/")[1];
      const imageUrl =  "/ugc/image";
      formData.append("bizType","review");
      formData.append("file1", image, imageName+"."+imageType);
      this.saveImageApi(imageUrl,formData);
    }
    this.imageList = [] as Array<Blob>
  }
  
  //file저장하기 api 
  saveImageApi(uploadUrl: string, formData: FormData){
    // 업로드해서 fileCd를 취득한다. (굳이 await로 안해도 될듯?)
    axios.post(uploadUrl, formData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => {
      const uploadedFile = r.data as SlvUgcImgVO;
      !this.review.files && (this.review.files = []);
      this.review.files.push(uploadedFile);
    });
  }

  //리뷰 수정하기
  getReview() {
    axios.get(`/ugc/${this.ugcCd}`).then((r) => {
      this.review = r.data as UgcVO;
    });
  }

  // meta(지급 포인트 정보)
  getUgcPolicyByPointTypeCd(pointTypeCd: string) {
    const policy = this.meta.filter(v=> v.pointTypeCd == pointTypeCd) as Array<UgcPointPolicy>;

    if(!policy.length) {
      return 0;
    }

    return policy[0].pointVal;
  }

  // 자동 저장(작성하던 리뷰)
  autoSaveObj = debounce(this.autoSave, 300);
  autoSave() {
    // 수정이면
    if (this.ugcCd) {
      return;
    }
    CommonUtils.putLocalStorageObject(Constants.AUTO_SAVED_REVIEW, this.review);
  }

  // 등록
  save(): void {
    if (!this.review.products.length) {
      // "a0007": "상품선택은 필수입니다",
      return alert(this.$t("review.a0007").toString());
    }
    if (!this.review.rating) {
      // "a0008": "평점은 필수입니다",
      return alert(this.$t("review.a0008").toString());
    }

    if (!this.review.text) {
      // "a0009": "내용은 필수입니다",
      return alert(this.$t("review.a0009").toString());
    }
    if (this.reviewTextLength < 30) {
      // "a0010": "30자 이상 작성해 주세요.",
      return alert(this.$t("review.a0010").toString());
    }

    // 등록하시겠습니까?
    if (confirm(this.$t("common.c0001").toString())) {
      this.review.tags = [];
      axios.post(`/ugc`, this.review).then(() => {
        CommonUtils.removeLocalStorageObject(Constants.AUTO_SAVED_REVIEW);
        this.$store.commit("touchKeepAlive");
        this.$router.push({ name: "Reviews" });
      });
    }
  }
  // 이전에 작성하던 데이터 불러오기
  reloadSavedReview(confirmed: boolean) {
    if (confirmed) {
      const savedReview = CommonUtils.getLocalStorageObject(Constants.AUTO_SAVED_REVIEW) as UgcVO;
      let hasSavedProduct = true;
      try {
        savedReview.products[0].productCd;
      } catch (e) {
        hasSavedProduct = false;
      }
      if (hasSavedProduct) {
        // 저장된 상품이 있으면
        this.review = savedReview;
        // 리뷰 작성 가능여부
        axios.get("/ugc/validate-ugc", { params: this.review.products[0].productCd }).then((r) => {
          if (r.data == false) {
            // "a0016": "리뷰를 작성할 수 없습니다."
            alert(this.$t("review.a0015"));
            this.$router.go(-1);
            return;
          }
        });
        this.showProductPop = false;
      }
    } else {
      CommonUtils.removeLocalStorageObject(Constants.AUTO_SAVED_REVIEW);
    }
    this.showSavedDocumentPop = false;
  }

  created(): void {
    //뷰티프로필 등록이 안되있으면 뷰티프로필 등록할건지 물어봄
    // axios.get("/ugc/validateBeautyProfileMember").then((r) => {
    //   if(r.data.isUgcMemCd == false){
    //     if(confirm(this.$t('mypage.c0002').toString())) {
    //       this.$router.push({name: 'ProfileInfo'});
    //     } else {
    //       this.$router.go(-1);
    //     }
    //   }
    // })
    // 포인트 지급 meta 정보
    axios.get(`/ugc/point-policys`, {params: {boardTypeCd: '055001'}}).then((r) => {
      this.meta = r.data as Array<UgcPointPolicy>;
    });

    // mypage 상품 리뷰쓰기
    if (this.propProduct) {
      this.review.products = [this.propProduct];
      this.showProductPop = false;
    }

    if (this.ugcCd) {
      // 수정
      this.showProductPop = false;
      this.getReview();
    } else {
      // 신규
      //주문건에 대한 리뷰 시 false 아니면 true
      this.showProductPop = !this.review.products ? true : false;
      // 이전에 작성하던 데이터 불러올지 여부
      if ((CommonUtils.getLocalStorageObject(Constants.AUTO_SAVED_REVIEW) as UgcVO) && !this.showProductPop) {
        this.showSavedDocumentPop = true;
      }
      this.$set(this.review, "files", []);
      this.$set(this.review, "ugcTypeCd", this.ugcTypeCd);
    }
  }
}
